import { Box, styled, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";
import { Table, Tag, Input, Button, Modal, Form, Space } from "antd";
import { useAxios } from "../../contexts/AxiosProvider";
import { DomainApi } from "../../services/DomainApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import UtcMinusFour from "../../utils/UtcMinusFour";

const { Search } = Input;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 8,
  },
};

const DomainContainer = styled(Box)(({ openDrawer, isDashboard }) => ({
  marginLeft: openDrawer ? 240 : isDashboard ? 0 : 80,
  // backgroundColor: "#f8f8ff",
  width: openDrawer
    ? "calc(100% - 255px)"
    : isDashboard
    ? "calc(100% - 5px)"
    : "calc(100% - 85px)",
  // border: openDrawer ? "2px solid green" : "2px solid skyblue",
  height: "calc(100vh - 70px)",
  // overflowY: "auto",
}));

const SearchAndFilter = styled(Box)(() => ({
  display: "flex",
  margin: "20px 20px",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const Domain = ({ openDrawer, userData, domainData }) => {
  const axios = useAxios();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [domainTable, setDomainTable] = useState({
    domainList: [],
    totalDomains: 0,
  });
  const [loading, setloading] = useState(false);
  const [isAddDomainModalOpen, setIsAddDomainModalOpen] = useState(false);
  const [domainName, setDomainName] = useState("");
  const [status, setStatus] = useState("");

  const [pagination, setpagiNation] = useState({ pageSize: 10, pageNo: 1 });

  const handlePagination = (page, pageSize) => {
    setpagiNation({ ...pagination, pageNo: page, pageSize: pageSize });
  };

  const showAddDomainModal = () => {
    setIsAddDomainModalOpen(true);
  };

  const handleCloseModal = () => {
    setDomainName("");
    setIsAddDomainModalOpen(false);
  };

  const handleAddDomain = async () => {
    const alphanumericWithLetter = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$/;
    if (!alphanumericWithLetter.test(domainName)) {
      enqueueSnackbar("Function should contain letters!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
    try {
      await DomainApi.createDomain(
        axios,
        userData.userId,
        userData.username,
        domainName
      );
      setIsAddDomainModalOpen(false);
      setDomainName("");
      enqueueSnackbar("Function Added Successfully", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      setDomainName("");
      fetchAllDomains();
      onReset();
    } catch (error) {
      if (error.response?.status === "409") {
        enqueueSnackbar("Function name Already exists !!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
      console.error("Error adding Function:", error);
      enqueueSnackbar("Unexpected Error Adding Function", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  const RenderClientComponent = (record) => {
    navigate(`/dep/client/${record.domain_id}`, {
      state: {
        ...userData,
      },
    });
  };

  const fetchAllDomains = async (
    pageNo = pagination.pageNo,
    pageSize = pagination.pageSize,
    status = ""
  ) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        search: false,
        domainSearchParam: "",
        pageNumber: pageNo,
        pageSize: pageSize,
        status: status,
      };
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        setDomainTable(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchAllDomains(pagination.pageNumber, pagination.pageSize, status);
  }, [status]);

  const deleteDomain = async (record) => {
    try {
      const response = await DomainApi.deleteDomain(axios, record.domain_id);
      if (response.status === 200) {
        enqueueSnackbar("Function Deleted", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllDomains();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const DomainColumns = [
    {
      title: "Function Name",
      dataIndex: "domain_name",
      key: "domain_name",
      onCell: (record) => {
        return {
          onClick: () => {
            RenderClientComponent(record); // Call openDrawer function here or pass any necessary data to Engagement component
          },
        };
      },
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
    },
    {
      title: "Creation Date",
      dataIndex: "creation_date",
      key: "creation_date",
      render: (text, record) => {
        const utcMinusFour = new UtcMinusFour(new Date(record.creation_date));
        return (
          <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
            {utcMinusFour.formatUtcMinusFour("yyyy-MM-dd hh:mm a")}
          </Typography>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      filters: [
        {
          text: "approved",
          value: "approved",
        },
        {
          text: "rejected",
          value: "rejected",
        },
        {
          text: "pending",
          value: "pending",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.status === value,
      render: (_, { status }) => (
        <>
          <Tag
            color={
              status === "approved"
                ? "green"
                : status === "pending"
                ? "yellow"
                : "red"
            }
            key={status}
          >
            {status}
          </Tag>
        </>
      ),
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   onCell: (record) => {
    //     return {
    //       onClick: () => {
    //         deleteDomain(record);
    //       },
    //     };
    //   },
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <a>Delete</a>
    //     </Space>
    //   ),
    // },
  ];

  const handleTableChange = (pagination, filters) => {
    const currentStatus = filters.status ? filters.status[0] : "";
    setStatus(currentStatus);
    fetchAllDomains(pagination.current, pagination.pageSize, currentStatus);
  };

  const onSearch = async (value, _e, info) => {
    try {
      const data = {
        user_id: location.state.userId,
        search: true,
        domainSearchParam: value,
        pageNumber: 0,
        pageSize: 0,
      };
      setloading(true);
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        setDomainTable(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <DomainContainer openDrawer={openDrawer} isDashboard={domainData.dashboard}>
      {domainData.isSearchFilterVisible && (
        <SearchAndFilter>
          <Search
            placeholder="Search Function"
            allowClear
            enterButton
            size="large"
            onSearch={onSearch}
            style={{ width: "20%" }}
          />
          {
            <Button type="primary" size="large" onClick={showAddDomainModal}>
              Add Function
            </Button>
          }
        </SearchAndFilter>
      )}
      <div
        style={{
          width: "100%",
          maxHeight: "90%",
          overflowY: "auto",
        }}
      >
        <Table
          bordered
          loading={loading}
          columns={DomainColumns}
          style={{ fontWeight: "640", margin: "20px" }}
          sticky
          dataSource={domainTable.domainList}
          pagination={{
            // defaultCurrent: 1,
            // pageSize: pagination.pageSize,
            // total: domainTable.totalDomains,
            // onChange: handlePagination,
            total: domainTable.totalDomains,
            pageSize: pagination.pageSize,
            current: pagination.pageNo,
            onChange: handlePagination,
          }}
          onChange={handleTableChange}
        />
      </div>
      {isAddDomainModalOpen && (
        <Modal
          title="Add Function"
          visible={isAddDomainModalOpen}
          onCancel={handleCloseModal}
          footer={null}
        >
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={handleAddDomain}
            style={{
              maxWidth: 600,
            }}
          >
            <Form.Item
              name="domain"
              label="Function"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                placeholder="Function Name"
                value={domainName}
                onChange={(e) => setDomainName(e.target.value)}
              />
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Space>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </DomainContainer>
  );
};

export default Domain;
